import WebServiceWrapper from "./WebServiceWrapper";

export const SelectedDiseaseAndTreatmentService = {
    GetSDTData,
    SaveSDTData,
};

function GetSDTData(patientId) {
    return WebServiceWrapper.Get(`/selecteddiseaseandtreatment/GetSDTData?patientId=${patientId}`);
}

function SaveSDTData(payload) {
    return WebServiceWrapper.PostWithHeader("/selecteddiseaseandtreatment/SaveSDTData", payload);
}